import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";
import MenuBar from "./MenuBar";
import { useAuth } from "../context/API_Client";

const Simulator = () => {
  const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
  });
  const { getUserDetails, getAccessToken } = useAuth();

  const merchantId = getUserDetails().merchantId;

  const [saveMessage, setSaveMessage] = useState([]);
  const [cleanStatsMessage, setCleanStatsMessage] = useState([]);
  const [simulationMessage, setSimulationMessage] = useState([]);

  useEffect(() => {
    getAllRows();
  }, []);

  // Get all data
  const getAllRows = () => {
    api
      .get(`/merchants/${merchantId}/simulations/success-rates`, {
        headers: {
          Authorization: getAccessToken(),
        },
      })
      .then((res) => {
        console.log("Success Rates " + JSON.stringify(res.data));
        adyenSuccessRateRef.current.value = res.data["ADYEN"];
        ccPPSuccessRateRef.current.value = res.data["CCPP"];
        worldpaySuccessRateRef.current.value = res.data["WORLDPAY"];
        mpgsSuccessRateRef.current.value = res.data["MPGS"];
        atomeSuccessRateRef.current.value = res.data["ATOME"];
        globalPaymentsSuccessRateRef.current.value = res.data["GLOBALPAYMENTS"];
        redDotPaymentsSuccessRateRef.current.value = res.data["REDDOT"];
        cybersourceSuccessRateRef.current.value = res.data["CYBERSOURCE"];
      })
      .catch((error) => {
        console.log("Api get user error - " + error);
      });
  };

  const adyenSuccessRateRef = useRef();
  const ccPPSuccessRateRef = useRef();
  const worldpaySuccessRateRef = useRef();
  const mpgsSuccessRateRef = useRef();
  const atomeSuccessRateRef = useRef();
  const globalPaymentsSuccessRateRef = useRef();
  const redDotPaymentsSuccessRateRef = useRef();
  const cybersourceSuccessRateRef = useRef();

  const updatePspSuccessRates = (event) => {
    if(event) {
      event.preventDefault()
    }

    api
      .post(
        `/merchants/${merchantId}/simulations/success-rates`,
        {
          ADYEN: adyenSuccessRateRef.current.value,
          CCPP: ccPPSuccessRateRef.current.value,
          WORLDPAY: worldpaySuccessRateRef.current.value,
          MPGS: mpgsSuccessRateRef.current.value,
          ATOME: atomeSuccessRateRef.current.value,
          GLOBALPAYMENTS: globalPaymentsSuccessRateRef.current.value,
          REDDOT: redDotPaymentsSuccessRateRef.current.value,
          CYBERSOURCE: cybersourceSuccessRateRef.current.value,
        },
        {
          headers: {
            Authorization: getAccessToken(),
          },
        }
      )
      .then((res) => setSaveMessage("Success Rates updated successfully!"))
      .catch((error) => setSaveMessage(error.message));
  };

  const cleanPaymentAuthStats = (event) => {
    if(event) {
      event.preventDefault()
    }

    api
      .post(
        `/merchants/${merchantId}/simulations/clean-slate`,
        {},
        {
          headers: {
            Authorization: getAccessToken(),
          },
        }
      )
      .then((res) =>
        setCleanStatsMessage(
          `${res.data.deletedRecords} stats records cleared Successfully!`
        )
      )
      .catch((error) => setCleanStatsMessage(error.message));
  };

  const startSimulation = (event) => {
    if(event) {
      event.preventDefault()
    }
    api
      .post(
        `/merchants/${merchantId}/simulations`,
        {},
        {
          headers: {
            Authorization: getAccessToken(),
          },
        }
      )
      .then((res) => setSimulationMessage(`Simulation started Successfully!`))
      .catch((error) => setSimulationMessage(error.message));
  };

  const stopSimulation = (event) => {
    if(event) {
      event.preventDefault()
    }
    api
      .delete(`/merchants/${merchantId}/simulations`, {
        headers: {
          Authorization: getAccessToken(),
        },
      })
      .then((res) => setSimulationMessage(`Simulation stopped Successfully!`))
      .catch((error) => setSimulationMessage(error.message));
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content-header" style={{ marginLeft: "10px" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h5>Simulator</h5>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/demo/simulator">Demo</Link>
                  </li>
                  <li className="breadcrumb-item active">Simulator</li>
                </ol>
              </div>
            </div>
          </div>
        </section>

        <section className="content" style={{ margin: "0 20px 0 20px" }}>
          <div
            className="card card-primary card-outline"
            style={{ width: "100%" }}
          >
            <div className="card-header">
              <h3
                className="card-title"
                data-card-widget="collapse"
                style={{ cursor: "pointer" }}
              >
                &nbsp;&nbsp;<i className="fas fa-cog"></i>&nbsp; PSP Success
                Rate Settings
              </h3>
              <div className="card-tools">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="collapse"
                >
                  <i className="fas fa-minus"></i>
                </button>
              </div>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Adyen Success Rate:</label>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-address-book"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Success Rate"
                        ref={adyenSuccessRateRef}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Checkout.com Success Rate:</label>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-address-book"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Success Rate"
                        ref={ccPPSuccessRateRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Worldpay Success Rate:</label>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-address-book"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Success Rate"
                        ref={worldpaySuccessRateRef}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>MPGS Success Rate:</label>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-address-book"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Success Rate"
                        ref={mpgsSuccessRateRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Atome Success Rate:</label>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-address-book"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Success Rate"
                        ref={atomeSuccessRateRef}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>GlobalPayments Success Rate:</label>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-address-book"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Success Rate"
                        ref={globalPaymentsSuccessRateRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>RedDot Success Rate:</label>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-address-book"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Success Rate"
                        ref={redDotPaymentsSuccessRateRef}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <label>Cybersource Success Rate:</label>
                    <div className="input-group mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="fas fa-address-book"></i>
                        </span>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Success Rate"
                        ref={cybersourceSuccessRateRef}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={updatePspSuccessRates}
                  >
                    Save changes
                  </button>
                  <div className="text-info">{saveMessage}</div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="card card-primary card-outline"
            style={{ width: "100%" }}
          >
            <div className="card-header">
              <h3
                className="card-title"
                data-card-widget="collapse"
                style={{ cursor: "pointer" }}
              >
                {" "}
                &nbsp;&nbsp;<i className="fas fa-play"></i>&nbsp; PSP Simulator
              </h3>
              <div className="card-tools">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="collapse"
                >
                  <i className="fas fa-minus"></i>
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-3">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-block"
                    onClick={startSimulation}
                  >
                    {" "}
                    &nbsp;&nbsp;<i className="fas fa-play"></i>&nbsp; Start
                    Simulation
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-block"
                    onClick={stopSimulation}
                  >
                    &nbsp;&nbsp;<i className="fas fa-stop"></i>&nbsp; Stop
                    Simulation
                  </button>
                  <div className="text-info">{simulationMessage}</div>
                </div>
                <div className="col-sm-1"></div>
                <div className="col-sm-8">
                  <p className="text-primary">
                    Payment Simulator Configuration -
                    <div style={{ padding: "10px 20px" }}>
                      <ul>
                        <li>Country - One of IN, US and SG</li>
                        <li>Currency - One of INR, USD and SGD</li>
                        <li>
                          Payment Method - One of VISA, Mastercard and
                          AmericanExpress
                        </li>
                        <li>Amount - Between 50 and 100 both inclusive</li>
                      </ul>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card card-danger card-outline collapsed-card">
            <div className="card-header">
              <h3
                className="card-title"
                data-card-widget="collapse"
                style={{ cursor: "pointer" }}
              >
                {" "}
                &nbsp;&nbsp;<i className="fas fa-exclamation-triangle"></i>
                &nbsp; Merchant Stats Cleanup
              </h3>
              <div className="card-tools">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="collapse"
                >
                  <i className="fas fa-plus"></i>
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-3">
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-block"
                    onClick={cleanPaymentAuthStats}
                  >
                    Clean Payment Auth Stats
                  </button>
                  <div className="text-info">{cleanStatsMessage}</div>
                </div>
                <div className="col-sm-1"></div>
                <div className="col-sm-7">
                  <p className="text-danger">
                    Please note that this will cleanup all the payment auth
                    stats data for current merchant. This will result into all
                    reports and search pages yielding nothing. This operation is
                    irreversible.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Simulator;
